// extracted by mini-css-extract-plugin
export default {"wrapper":"Route_wrapper__D4q+M","rightColumn":"Route_rightColumn__LNxP5"};